import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import Transactions from '../components/transactions/Transactions'
import {
  getTransactions,
  resetTransactionsState
} from '../store/actions/transactions'
import { trackGTMDataLayer } from 'wrappers/trackGTMDataLayer'
import {
  DEFAULT_CONTAINER_STATE,
  TRANSACTIONS_PROCESS_STEP
} from '../constants/containerStates'
import { NUMBER_OF_TX_PER_PAGE } from '../constants/transactions'
import FuturePointsInfoPopup from '../components/popups/transactions/FuturePointsInfo'

const TransactionsContainer = ({
  getTransactions,
  transactionsProfile: {
    transactions,
    isLast,
    loading,
    // loadingTx,
    offset,
    totalTx
  },
  tokenProfile,
  accountProfile,
  resetTransactionsState
}) => {
  const { t } = useTranslation()

  const [popupState, setPopupState] = useState({
    id: DEFAULT_CONTAINER_STATE.NONE,
    data: null
  })

  useEffect(() => {
    getTransactions(0, true, false)
  }, [getTransactions])

  useEffect(() => {
    return () => {
      resetTransactionsState()
    }
  }, [])

  const location = useLocation()
  useEffect(() => {
    trackGTMDataLayer(location.pathname)
  }, [])

  const handleScroll = useCallback(() => {
    if ((offset === 0 || offset < totalTx) && !isLast) {
      getTransactions(offset + NUMBER_OF_TX_PER_PAGE, false, true)
    }
  }, [offset])

  const handleNoPopup = () => {
    setPopupState({ data: null, id: DEFAULT_CONTAINER_STATE.NONE })
  }

  const handlePopupSubmit = () => {
    switch (popupState.id) {
      case TRANSACTIONS_PROCESS_STEP.FUTURE_POINTS_INFO:
        handleNoPopup()
        break

      default:
        break
    }
  }

  const renderPopup = () => {
    switch (popupState.id) {
      case TRANSACTIONS_PROCESS_STEP.FUTURE_POINTS_INFO:
        return (
          <FuturePointsInfoPopup
            onSubmit={handlePopupSubmit}
            t={t}
            isNft={popupState.data?.isNft}
          />
        )
      default:
        break
    }
  }

  const handleShowFuturePointsInfo = (isNft) => {
    setPopupState({
      id: TRANSACTIONS_PROCESS_STEP.FUTURE_POINTS_INFO,
      data: { isNft }
    })
  }

  return (
    <>
      <Transactions
        transactions={transactions}
        loading={loading}
        tokenProfile={tokenProfile}
        accountProfile={accountProfile}
        onShowFuturePointsInfo={handleShowFuturePointsInfo}
        t={t}
        tableHeaders={[
          { id: 'description', label: t('transaction-history.description') },
          { id: 'amount', label: t('transaction-history.amount') },
          { id: 'date', label: t('transaction-history.date') },
          { id: 'status', label: t('transaction-history.status') }
        ]}
        scrollDataProps={{
          next: handleScroll,
          hasMore: !isLast
        }}
      />
      {renderPopup()}
    </>
  )
}

const mapStateToProps = ({
  transactionsReducer,
  mainReducer,
  accountReducer
}) => {
  const { transactionsProfile } = transactionsReducer
  const { tokenProfile } = mainReducer
  const { accountProfile } = accountReducer

  return {
    transactionsProfile,
    tokenProfile,
    accountProfile
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getTransactions,
      resetTransactionsState
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TransactionsContainer)
